import { useEffect } from "react";
import PropTypes from "prop-types";
import { CustomContainer, connect } from "../../atoms/DependencyHelper";
import Image from "../../atoms/image/image";
import {
  imagePrefix,
} from "../../../utils/helperServices";
import labels from "../../../config/labels";
import config, {
  EnvConfig,
}  from "../../../config/index";
import * as Analytics from "../../../services/analyticsUtag";
import {
  MiniAppUtagUtil
} from '../../../utils/miniAppUtagUtil';
import styles from "./PaymentRedirect.module.scss";

const PaymentRedirect = ({
  userLoggedIn,
  profileData,
  paymentConfiguration,
  applicationType,
  paymentMethodUrl,
  postOrderResponse,
  paymentOptionsEnabled,
  customerStatus,
  cartProducts,
  deliveryDetails,
  authDetailsData,
  isMiniApp,
}) => {
  const env = config.env;
  const paymentCallbackUrl =
    applicationType == "normal"
      ? config.envConfigs[env].paymentCallback
      : config.envConfigs[env].postPaymentCallback;
  const paymentProvision = config.envConfigs[env].paymentProvision;
  const paymentConfig = paymentConfiguration;
  const customerIdentifier =
    userLoggedIn && profileData?.profileID ? profileData?.profileID : "";
  const niToggle = postOrderResponse?.niMigrationFeatureToggle;
  const newUrl= postOrderResponse?.paymentPageUrl;


  /**
   * Redirect to payment gateway
   *
   * @call page load
   */
  useEffect(() => {

    if (isMiniApp) {

      const salesAnalyticsData = MiniAppUtagUtil.getSalesAnalyticsData(cartProducts, applicationType);

      const analytics = {
        ...Analytics.getProfileData(userLoggedIn, profileData),
        ...salesAnalyticsData,
        delivery_type: deliveryDetails?.receiveType === "store"
          ? "collect"
          : "deliver",
        authentication_id_type: authDetailsData?.idType === "PASSPORT"
          ? "passport"
          : "id",
        customerStatus,
      };

      window.location = `${EnvConfig.miniAppUrl}?orderId=${postOrderResponse?.productOrderId}&analytics=${encodeURIComponent(JSON.stringify(analytics))}`;
      return;
    }

    if(niToggle===true) {
      window.location.href = newUrl
      return
    }

    window.setTimeout(() => {
      document.ucfCheckout.submit.bind(document.ucfCheckout);
      document.ucfCheckout.submit();
    }, 800);
  }, []);

  if (isMiniApp) {

    return (

      <CustomContainer className={styles["payment-redirect"]}>
        <CustomContainer className={styles["icon"]}>
          <Image img_path={`${imagePrefix}/assets/images/lock-loading.gif`} />
        </CustomContainer>
        <CustomContainer className={styles["desc"]}>
          {labels.lbl_payment_redirect}
        </CustomContainer>
      </CustomContainer>
    );
  }

  return (
    <>
      <CustomContainer className={styles["payment-redirect"]}>
        <CustomContainer className={styles["icon"]}>
          <Image img_path={`${imagePrefix}/assets/images/lock-loading.gif`} />
        </CustomContainer>
        <CustomContainer className={styles["desc"]}>
          {labels.lbl_payment_redirect}
        </CustomContainer>
        <form
          method="post"
          name="ucfCheckout"
          id="ucfCheckout"
          action={
            paymentOptionsEnabled && paymentMethodUrl
              ? paymentMethodUrl
              : paymentConfig.paymentGatewayUrl
          }
        >
          <input
            type="hidden"
            name="PayserverUser"
            id="PayserverUser"
            value={paymentConfig.payServerUser}
          />
          <input
            type="hidden"
            name="transactionStatusCallbackUrl"
            id="transactionStatusCallbackUrl"
            value={paymentConfig.transactionStatusCallbackUrl}
          />
          <input
            type="hidden"
            name="transactionCompletedUrl"
            id="transactionCompletedUrl"
            value={paymentCallbackUrl}
          />
          <input
            type="hidden"
            name="redirectURL"
            id="redirectURL"
            value={paymentCallbackUrl}
          />
          <input
            type="hidden"
            name="failureURL"
            id="failureURL"
            value={paymentCallbackUrl}
          />
          <input
            type="hidden"
            name="TransactionStatusCallbackFormat"
            id="TransactionStatusCallbackFormat"
            value={paymentConfig.transactionStatusCallbackFormat}
          />
          <input
            type="hidden"
            name="TransactionStatusCallbackMethod"
            id="TransactionStatusCallbackMethod"
            value={paymentConfig.transactionStatusCallbackMethod}
          />
          <input
            type="hidden"
            name="MerchantReference"
            id="MerchantReference"
            value={postOrderResponse?.productOrderId}
          />
          <input
            type="hidden"
            name="Currency"
            id="Currency"
            value={paymentConfig.currency}
          />
          <input
            type="hidden"
            name="TransactionType"
            id="TransactionType"
            value={paymentConfig.transactionType}
          />
          <input
            type="hidden"
            name="MerchantIdentifier"
            id="MerchantIdentifier"
            value={paymentConfig.merchantIdentifier}
          />
          <input
            type="hidden"
            name="CustomerIdentifier"
            id="CustomerIdentifier"
            value={customerIdentifier}
          />
          <input
            type="hidden"
            name="EncXML"
            id="EncXML"
            value={postOrderResponse?.payment?.encryptedPaymentDetails}
          />
          <input
            type="hidden"
            name="EncType"
            id="EncType"
            value={paymentConfig.encType}
          />
        </form>
      </CustomContainer>
    </>
  );
};

PaymentRedirect.propTypes = {
  customerStatus: PropTypes.string,
};

const mapStateToProps = (state) => ({
  paymentMethodUrl: state.checkoutDetails.paymentMethodUrl,
  postOrderResponse: state.checkoutDetails.postOrderResponse,
  deliveryDetails: state.creditCheckDetails.deliveryDetails,
  authDetailsData: state.checkoutDetails.authDetails,
  isMiniApp: state.navDetails.isMiniApp,
});

export default connect(mapStateToProps)(PaymentRedirect);
